import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import {
  BaseText,
  ButtonIconContextual,
  ButtonSecondary,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { AvailableBalanceModal } from '@/modules/trade/components/AvailableBalanceModal';
import { Money } from '@/modules/common/components/MoneyV2';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { AvailableBalanceData } from '@/modules/trade/services/unified-account/types';

interface Props {
  availableBalanceData?: AvailableBalanceData;
  loading: boolean;
  error: boolean;
}
interface Emits {
  'on-retry': () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableBalance',
  props: {
    availableBalanceData: null,
    loading: { type: Boolean },
    error: { type: Boolean }
  },
  setup(__props: any, { emit }: { emit: ({
  'on-retry': () => void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  availableBalanceData?: AvailableBalanceData;
  loading: boolean;
  error: boolean;
}





const isModalOpen = ref(false);

const availableToOperateValue = computed(() => {
  return props.availableBalanceData?.availableToOperateValue?.formatted || '-';
});

const emitOnRetry = () => {
  emit('on-retry');
};

const openModal = () => {
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
};

return { __sfc: true,props, emit, isModalOpen, availableToOperateValue, emitOnRetry, openModal, closeModal, BaseText, ButtonIconContextual, ButtonSecondary, SkeletonLoader, AvailableBalanceModal, Money, NebraskaColors }
}

})